import "./WhitePapersLanding.css";
import WPButton from "./WPButton";

export default function WPCard({ title, description, backgroundUrl, label, pdfUrl, target, customClass, disabled }) {
    return (
        <div className={"cardWrapper"}>
            <div className={"wpCard"} style={{ backgroundImage: `url(${backgroundUrl})` }}>
                <h3>{title}</h3>
                <h4>{description}</h4>
            </div>
            <WPButton
                label={label}
                action={pdfUrl}
                target={target}
                customClass={customClass}
                disabled={disabled}
            />
        </div>
    );
}
